import { CustomFlowbiteTheme } from 'flowbite-react';

export const textInputTheme: CustomFlowbiteTheme['textInput'] = {
    field: {
        icon: {
            base: 'pointer-events-auto absolute inset-y-0 left-0 flex items-center pl-3',
            svg: '',
        },
        rightIcon: {
            base: 'pointer-events-auto absolute inset-y-0 right-0 flex items-center pr-3',
            svg: '',
        },
        input: {
            base:
                // font-sans is explicit because Preflight is off: without it the input's text
                // falls back to the browser default instead of the design-system font
                'block w-full border border-solid text-ellipsis text-system-on-surface font-sans' +
                // disabled
                ' disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-catapult-grey-50' +
                ' disabled:helperText-opacity-50 disabled:placeholder-opacity-50',
            sizes: {
                sm: 'p-2 text-sm',
                md: 'p-2.5 text-sm',
                lg: 'text-base p-4',
            },
            colors: {
                /* elements: text | bg | border | placeholder */
                gray:
                    // rest
                    'bg-system-surface-container border-system-outline-variant text-system-on-surface placeholder:text-system-on-surface-variant' +
                    // focus: a border tint alone is too faint (WCAG 2.4.7, 1.4.11), so a 2px ring as on other controls
                    ' focus:border-system-outline focus:ring-0 focus:outline-none' +
                    ' focus-visible:outline focus-visible:outline-2 focus-visible:outline-system-primary',
                failure:
                    // rest
                    'bg-system-surface-container border-system-error text-system-on-surface placeholder:text-system-on-surface-variant' +
                    // focus
                    ' focus:border-system-error focus:ring-0 focus:outline-none' +
                    ' focus-visible:outline focus-visible:outline-2 focus-visible:outline-system-error',
            },
        },
    },
};
